import {HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  AprimaCacheInstance,
} from 'webcommon/legacy-common';
import {
  PermissionNames,
  SecurityPermissionsDto,
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class PermissionRepository {
  constructor(
    private readonly httpClientService: PrmHttpClientService,
  ) { }

  getSecurityPermissions(permissionName: PermissionNames, cache?: AprimaCacheInstance): Observable<SecurityPermissionsDto> {
    const endpointUrl = `permissions/${permissionName}`;
    return this.httpClientService.sendGetRequest(endpointUrl, undefined, { cache });
  }

  // this looks up permissions for the current user like the method above,
  // but by ObjectUid, instead of by permission name
  getSecurityPermissions2(objectId: string, cache?: AprimaCacheInstance): Observable<SecurityPermissionsDto> {
    const endpointUrl = `permissions`;
    let params = new HttpParams();
    params = params.set('objectId', objectId);
    return this.httpClientService.sendGetRequest(endpointUrl, params, { cache });
  }
}
